import styled from "@emotion/styled";
import { ChangeEvent, FormEvent, useState } from "react";
import { AddUserButton } from "../../assets/icons/icons";
import theme from "../../theme";
import { SearchForm } from "../../components/common/SearchForm";
import { Button } from "../../components/common/Button";
import { SystemSetting } from "../../types/types";
import { SelectBoxGroupId } from "../../components/SelectBoxGroupId";
import { FetchParams } from "./manageNok";
import { useI18n } from "../../locales";

interface subHeaderProps {
  onClickBtn: ({ searchKey, groupId }: FetchParams) => void;
  openModal: () => void;
  systemSetting: SystemSetting | null;
}
const SubHeader: React.FC<subHeaderProps> = (props) => {
  const { onClickBtn, openModal, systemSetting } = props;
  const [input, setInput] = useState("");
  const [groupSub, setGroupSub] = useState("all"); // 하위그룹코드(화면용)
  const { t } = useI18n();

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInput(event.currentTarget.value);
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onClickBtn({
      searchKey: input,
      groupId: groupSub,
    });
  };

  return (
    <Wrapper>
      {/* 하위 그룹 조회 */}
      <SelectBoxGroupId
        groupSub={groupSub}
        setGroupSub={setGroupSub}
        width={160}
      />

      <SearchForm
        onSubmit={onSubmit}
        placeholder={t.manageNok.searchPlaceholder}
        onChange={onChange}
        inputValue={input}
        setInputValue={setInput}
        bottom="0"
        width="375px"
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Button
          bgColor={theme.color.aquamarine_500}
          hoverColor={theme.color.aquamarine_600}
          onClick={openModal}
          height="40px"
          isDisabled={!systemSetting?.create}
        >
          <AddUserButtonContainer>
            <AddUserButton />
          </AddUserButtonContainer>
          {t.manageNok.registerRecipient}
        </Button>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 92px;
  background: ${theme.color.neutral_50};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 23px;
  gap: 20px;
`;

const AddUserButtonContainer = styled.div`
  margin-top: 3px;
`;

export default SubHeader;
